import { Layout } from 'components/layout'
import { Router } from 'components/router'
import { StoreProvider } from 'context'
import { EsConfigProvider } from 'context/elasticsearch/esConfigContext'
import { BrowserRouter } from 'react-router-dom'

function App() {
	return (
		<div className='AppContainer'>
			<BrowserRouter>
				<StoreProvider>
					<EsConfigProvider>
						<Layout>
							<Router />
						</Layout>
					</EsConfigProvider>
				</StoreProvider>
			</BrowserRouter>
		</div>
	)
}

export default App
